import { SaveTipoMetrica } from "../../components";

export default function CreateTipoMetricaPage() {
  return <SaveTipoMetrica titulo="Crear tipo de métrica" />;
}
